<script>
	export default {
		name: 'LeafletMapSelection',
		props: {
			map: {
				type: Object,
				required: true
			},
			leaflet: {
				type: Object,
				required: true
			},
			geoJsonGeometry: {
				type: String
			}
		},		
		created() {
			this.canvas = this.leaflet.canvas();
			//переопределяем то как отрисовываются линии. чтобы было под требования UI
			const _fillStrokeBase = this.canvas._fillStroke;
			this.canvas._fillStroke = (ctx, layer) => {
				//рисуем белую линию
				ctx.globalAlpha = layer.options.opacity;
				ctx.lineWidth = 6;
				ctx.strokeStyle = 'white';
				ctx.lineCap = layer.options.lineCap;
				ctx.lineJoin = layer.options.lineJoin;
				ctx.stroke();
				//а здесь уже рисуем всё остальное согласно options объекта
				_fillStrokeBase(ctx, layer);
			};

			this.$once("hook:beforeDestroy", () => {
				if (this.canvas)
					this.canvas.remove();
			});
			this.highlightGeometry(this.geoJsonGeometry);
		},
		methods: {
			highlightGeometry(value) {
				if (!this.canvas)
					return;
				if (this._selection) {
					this._selection.remove();
					this._selection = null;
				}
				if (value) {
					this._selection = this.leaflet.geoJSON(JSON.parse(value), {
						pointToLayer: (geojson, latlng) => {
							return this.leaflet.circleMarker(latlng)
						},
						renderer: this.canvas,
						fillColor: 'rgba(108, 197, 202)',
						fillOpacity: 0.15,
						color: '#0B9096',
						opacity: 1,
						interactive:false
					});
					this._selection.addTo(this.map);
				}
			}
		},
		watch: {
			geoJsonGeometry: {
				handler: 'highlightGeometry'				
			}
		},
		render() {
			return this.$slots.default;
		}
	}
</script>
